<form class="form" [formGroup]="contractForm">
  <ix-typography format="h3">Results</ix-typography>

  <ix-layout-grid class="layout-grid-form" gap="12">
    <ix-row>
      <ix-col size="4" size-sm="12"> </ix-col>
      <ix-col>
        <ix-typography class="price-type" format="h4">{{
          contractForm.controls[fields.TYPE_OF_PRICING_1].value
        }}</ix-typography>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="4" size-sm="12">
        <label class="tooltip-onboarding_total" aria-describedby="tooltip-onboarding_total">Onboarding (total)</label>
        <ix-tooltip id="tooltip-onboarding_total" for=".tooltip-onboarding_total">{{
          contractForm.controls[fields.ONBOARDING_TOTAL_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <div class="input-with-euro">
          <ix-input
            type="text"
            [formControlName]="fields.ONBOARDING_TOTAL"
            readonly="true"
            class="right-aligned"
          ></ix-input>
        </div>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-col size="4" size-sm="12">
        <label class="tooltip-RIOpSpackageoprice" aria-describedby="tooltip-RIOpSpackageoprice">{{
          contractForm.controls[fields.RIOPS_PACKAGE_TEXT].value
        }}</label>
        <ix-tooltip id="tooltip-RIOpSpackageoprice" for=".tooltip-RIOpSpackageoprice">{{
          contractForm.controls[fields.RIOPS_PACKAGE_PRICE_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <div class="input-with-euro">
          <ix-input
            type="text"
            [formControlName]="fields.RIOPS_PACKAGE_PRICE"
            readonly="true"
            class="right-aligned"
          ></ix-input>
        </div>
      </ix-col>
    </ix-row>
    @if (contractForm.controls[fields.RIOPS_DISCOUNT_VISIBLE].value === 'true') {
      <ix-row>
        <ix-col size="4" size-sm="12">
          <label class="tooltip-RIOpSDiscount" aria-describedby="tooltip-RIOpSDiscount">RIOpS Discount</label>
          <ix-tooltip id="tooltip-RIOpSDiscount" for=".tooltip-RIOpSDiscount">{{
            contractForm.controls[fields.RIOPS_DISCOUNT_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <div class="input-with-euro">
            <ix-input
              type="text"
              [formControlName]="fields.RIOPS_DISCOUNT"
              readonly="true"
              class="right-aligned"
            ></ix-input>
          </div>
        </ix-col>
      </ix-row>
    }
    <ix-row>
      <ix-col size="4" size-sm="12">
        <label class="tooltip-totalprice" aria-describedby="tooltip-totalprice">TOTAL PRICE</label>
        <ix-tooltip id="tooltip-totalprice" for=".tooltip-totalprice">{{
          contractForm.controls[fields.TOTAL_PRICE_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <div class="input-with-euro">
          <ix-input type="text" [formControlName]="fields.TOTAL_PRICE" readonly="true" class="right-aligned"></ix-input>
        </div>
      </ix-col>
    </ix-row>
    <ix-row>
      <ix-typography class="disclaimer" bold="true">{{
        contractForm.controls[fields.GENERAL_DISCLAIMER_TEXT].value
      }}</ix-typography>
    </ix-row>
    <ix-row>
      <ix-typography>{{ contractForm.controls[fields.VERSION_TEXT].value }}</ix-typography>
    </ix-row>
    <ix-row>
      <ix-typography>Frontend and backend version: {{ version }}</ix-typography>
    </ix-row>
    <ix-row>
      <ix-typography class="line-breaks" textColor="soft">{{
        contractForm.controls[fields.DESCRIPTION_TEXT].value
      }}</ix-typography>
    </ix-row>
  </ix-layout-grid>
  <div class="button-container">
    <ix-button variant="subtle-primary" class="m-1 back-button" (click)="stepBack()">Back</ix-button>
  </div>
</form>
